var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoneyBillTransfer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M548.7 27.3L585.4 64l-45.3 0-15.5 0L384 64l-.3 0L96 64c-35.3 0-64 28.7-64 64l0 220.1 14.1-14.1L64 316.1 64 192c53 0 96-43 96-96l364.3 0 15.8 0 45.3 0-36.7 36.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l64-64c3-3 4.7-7.1 4.7-11.3s-1.7-8.3-4.7-11.3l-64-64c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6zM128 96c0 35.3-28.7 64-64 64l0-32c0-17.7 14.3-32 32-32l32 0zM54.6 448l45.3 0s0 0 0 0L544 448c35.3 0 64-28.7 64-64l0-220.1-14.1 14.1L576 195.9 576 320s0 0 0 0c-53 0-96 43-96 96l-223.6 0-.4 0L54.6 416l36.7-36.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-64 64c-3 3-4.7 7.1-4.7 11.3s1.7 8.3 4.7 11.3l64 64c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L54.6 448zM576 352s0 0 0 0l0 32c0 17.7-14.3 32-32 32l-32 0c0-35.3 28.7-64 64-64zM256 256a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zm160 0a96 96 0 1 0 -192 0 96 96 0 1 0 192 0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoneyBillTransfer);
export default __webpack_public_path__ + "static/media/money-bill-transfer.7f5a99e20fbac3be8da8e6807bfd4312.svg";
export { ForwardRef as ReactComponent };